import { useEffect } from 'react';
import { VolumeControls } from '@/meta/VolumeControls';

// Пауза уровня (кит §04 «Диалоги и оверлеи»): громкости + «Продолжить» (success),
// ниже в ряд «Заново» (ghost) и «Выйти» (danger). Подтверждения выхода нет: прогресс
// уровня — одна попытка, а «Выйти» и так стоит вторым шагом после шестерёнки.
// Esc и клик по затемнению = «Продолжить».
export function PausePanel({ canRestart, onResume, onRestart, onExit }: {
  canRestart: boolean;
  onResume: () => void;
  onRestart: () => void;
  onExit: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onResume(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onResume]);

  return (
    <div
      className="play-overlay"
      data-testid="play-pause"
      onPointerDown={(e) => { if (e.target === e.currentTarget) onResume(); }}
    >
      <div className="result-panel pause-panel" role="dialog" aria-modal="true" aria-labelledby="pause-title">
        <h2 id="pause-title" className="result-title pause-title">Пауза</h2>
        <div className="pause-volumes">
          <VolumeControls />
        </div>
        <div className="result-actions">
          <button className="btn btn-accent" data-testid="pause-resume" onClick={onResume} autoFocus>
            Продолжить
          </button>
          <div className="pause-row">
            {canRestart && (
              <button className="btn btn-ghost btn-sm" data-testid="pause-restart" onClick={onRestart}>
                Заново
              </button>
            )}
            <button className="btn btn-danger btn-sm" data-testid="pause-exit" data-sfx="back" onClick={onExit}>
              Выйти
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
